type Size = 'small' | 'medium' | 'large'

export function ProgressBar({
  className,
  percentage,
  progressClass,
  size,
  style,
}: {
  className?: string
  percentage: number
  progressClass?: string
  size: Size
  style?: React.CSSProperties
}): React.ReactElement {
  return (
    <div className={`w-full flex rounded shadow-experimental bg-white ${getSize(size)} ${className}`} style={style}>
      <div
        className={`bg-gradient-to-t from-purple to-[#A87FDE] rounded transition-all ${progressClass}`}
        style={typeof percentage === 'number' ? { width: `${percentage}%` } : undefined}
      />
    </div>
  )
}

function getSize(size: Size): string {
  switch (size) {
    case 'small':
      return 'h-2'

    case 'medium':
      return 'h-3'

    case 'large':
      return 'h-4'

    default:
      return ''
  }
}
